export const LOGO_URL = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ44oEigIja_Oc2XIpDMQVSHrpTS1AZq6gjNA&usqp=CAU"

export const CDN_URL = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/"

export const CDN_IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_100,h_100,c_fill/"

export const CORS_PROXY_URL = "https://corsproxy.io/?";